var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page404"},[_c('Block404')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }